import { action, autorun, IReactionDisposer, runInAction } from 'mobx';
import { StorageModel } from '../storage/model';
import { RequestController } from '../request/controller';
import { TOKEN, USER, AuthModel } from './model';
import { BASKET_IDENTITY, BASKET_TRACKS } from '../basket/model';
import {User} from '../../types/user';
import {HttpRequestError} from "../../lib/Error";

export class AuthController {
  constructor(
    private model: AuthModel,
    private storage: StorageModel,
    private request: RequestController
  ) {
    this._disposers = [];

    if (!process.env.SERVER) {
      if (this.model.token) {
        this.getSession();
      } else {
        this.model.hasFetched = true;
      };

      this.model.hasBetaInvite = !!document.cookie
        .split(';')
        .map(part => part.trim().split('='))
        .find(part => part[0] === 'invite')

      this._disposers.push(autorun(() => {
        if (this.model.user && this.model.mustReAuth) {
          this.logout(false);
        }
      }));
    }
  }

  private _disposers: IReactionDisposer[];

  dispose = () => {
    this._disposers.forEach(dispose => dispose());
  };

  @action
  logout = (redirect = true, showReAuthModal = false) => {
    this.storage.delete(TOKEN);
    this.storage.delete(USER);
    this.storage.delete('trackLogin');
    this.storage.delete(BASKET_IDENTITY);
    this.storage.delete(BASKET_TRACKS);

    if (redirect && window && window.location && window.location.reload) {
      window.location.reload();
    }

    if (showReAuthModal) {
      this.model.mustReAuth = true;
    }
  };

  @action
  getSession = async () => {
    try {
      const resp = await this.request.get({ url: '/user/session' });

      if (resp.status >= 400) {
        return this.logout(false, true);
      }

      const { data } = await resp.json();
      this.setUser(data);
      runInAction(() => this.model.hasFetched = true);
    } catch (e) {
      this.logout(false);
      runInAction(() => this.model.hasFetched = false);
    }
  };

  @action
  setUser = (user: User) => {
    this.storage.setItem(USER, user);
  }
}